<template>
  <header>
    <div class="container_w clear">
      <div class="left header_l">
        <a href="javascript:;"><h1 class="logo_icon left" @click="goHome"></h1></a>
        <dl class="left">
          <dt>CSC Sales and Service Hotline:</dt>
          <dd><em>+86 28 8888 8888(7x24h)</em></dd>
        </dl>
      </div>
      <ul class="right header_r">
        <li class="left"><a href="javascript:;" @focus="subBlur"></a></li>
        <li class="left">
          <a href="javascript:;" @click="showCountry" :class="{'country_active':showState}"><i
              :class="c_Class"></i>{{ c_title }}</a>
          <div class="show_c_box" v-if="showState">
            <p>Select Country/Region</p>
            <div class="countryList">
              <a href="javascript:;" @click="showList" :class="{'country_active':showCountryList}"><i
                  :class="countryCheck.rClass"></i>{{ countryCheck.name }}</a>
              <div class="c_list_sty" v-if="showCountryList">
                <a href="javascript:;"
                   v-for="(item,index) in countryList" :key="index"
                   @click="toggleCountry(index)" :class="{'ischeck':item.isCheck}">
                  <i :class="item.rClass"></i>
                  {{ item.name }}
                </a>
              </div>
            </div>
            <p>Select Language</p>
            <div class="language_sty">
              <a href="javascript:;">{{ language }}</a>
            </div>
            <input class="si_c_btn_common" type="button" @blur="subBlur" value="Submit" @click="countrySubmit">
          </div>
        </li>
         <li class="left">
<!--           <div class="auth-buttons">-->
<!--             <button class="login-btn" @click="goLogin">Login</button>-->
<!--             <button class="signup-btn" @click="goSignup">Sign up</button>-->
<!--           </div>-->
         </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  components: {},
  name: "Header",
  data() {
    return {
      c_title: '',
      c_Class: '',
      countryCode: '',
      showState: false,
      showCountryList: false,
      countryList: [],
      countryCheck: {},
      language: "English"
    };
  },
  props: {},
  watch: {},
  methods: {
    goHome() {
      this.$router.push('/')
    },
    goLogin() {
      this.$router.push('/loginNew')
    },
    goSignup() {
      this.$router.push('/signup')
    },
    showCountry() {
      this.showState = !this.showState
      this.rClass = this.c_Class
      console.log(this.countryList)
      this.countryList.forEach((i) => {
        if (i.rClass == this.c_Class) {
          this.countryCheck = i
          i.isCheck = true
        } else {
          i.isCheck = false
        }
      })
    },
    showList() {
      this.showCountryList = !this.showCountryList
      this.countryList.forEach((item) => {
        if (item.name == this.countryCheck.name) {
          item.isCheck = true
        } else {
          item.isCheck = false
        }
      })

    },
    toggleCountry(k) {
      console.log(this.countryList[k])
      this.countryCheck = this.countryList[k]
      this.showCountryList = false

      if (this.countryCheck.code == "CN-EN") {
        this.language = "简体中文"
      } else {
        this.language = "English"
      }
    },
    countrySubmit() {
      this.showState = false
      this.c_Class = this.countryCheck.rClass
      if (this.countryCheck.code == "CN-EN") {
        // 跳转中国站
        window.location.href = 'http://www.sichuanair.com/'
        return
      }
      this.c_title = `${this.countryCheck.name} | English`
      this.$Utils.setSession('COUNTRY_CODE', this.countryCheck.code)
      this.$Utils.setSession('COUNTRY_OfficeID', this.countryCheck.OfficeID)
      this.countryLine(this.countryCheck.code)
      window.location.reload()
    },
    countryLine(code) {
      if(process.env.NODE_ENV === "development"){
        const data = {"officeId":"LAX3U12TK","rType":"ResourceEN","SearchURL":"https://wftc3.e-travel.com/plnext/SichuanDX/Override.action","GlobalUrl":"https://global.sichuanair.com/"}
        this.$Utils.setSession('COUNTRY_LINE', data)
      }else{
        this.$Ajax.post(`${this.$BASE_url}Home/GetOfficeId/${code}`)
            .then((response) => {
              this.$Utils.setSession('COUNTRY_LINE', response.data)
            })
            .catch((error) => {
              console.log(error);
            });
      }

    },
    subBlur() {
      console.log(1111)
      this.showState = false
    }
  },
  filters: {},
  computed: {},
  created() {
    console.log('opt', process.env.NODE_ENV)
    var opt = ''
    if (process.env.NODE_ENV === "development") {
      opt = 'US-EN'
    } else {
      opt = window.location.href.split('#')[0].split('?')[1].split('=')[1] || 'US-EN';


    }
    if (!this.$Utils.getSession('COUNTRY_CODE')) {
      this.$Utils.setSession('COUNTRY_CODE', opt)
    }

    var countryCode = this.$Utils.getSession('COUNTRY_CODE') || opt
    var list = []
    console.log('1231312',WEBSITESJSON)
    WEBSITESJSON.forEach((i) => {
      if (i.simpleName) {
        list.push({
          OfficeID: i.OfficeID,
          name: i.SiteName,
          rClass: 'flag_' + i.simpleName,
          code: i.simpleName + '-EN',
          isCheck: false
        })
      }
    })
    console.log(list, '---', countryCode)
    list.forEach((item) => {
      console.log(item.code, 'code----')
      if (item.code == countryCode) {
        console.log('ok----')
        this.c_title = `${item.name} | English`
        this.c_Class = item.rClass
        this.countryCode = item.code
        item.isCheck = true
        this.$Utils.setSession('COUNTRY_OfficeID', item.OfficeID)
        this.$Utils.setSession('COUNTRY_CODE', item.code)
      }
    })
    console.log(this.$Utils.getSession('COUNTRY_OfficeID'))
    this.countryLine(countryCode)
    this.countryList = list
  },
  mounted() {
  },
  destroyed() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.country_active {
  color: #D8000F !important;

  &::after {
    background-image: url(../../assets/common/icon_com_sj_up.png) !important;
  }
}

.ischeck {
  &::after {
    display: inline-block !important;
    background-image: url(../../assets/home/icon_com_choose_sellist.png) !important;
  }
}

.flag_CN {
  background-image: url(../../assets/flag/flag_CN.png);
}

.flag_AU {
  background-image: url(../../assets/flag/flag_AU.png);
}

.flag_Burma {
  background-image: url(../../assets/flag/flag_Burma.png);
}

.flag_CA {
  background-image: url(../../assets/flag/flag_CA.png);
}

.flag_CZ {
  background-image: url(../../assets/flag/flag_Czech.png);
}

.flag_HK {
  background-image: url(../../assets/flag/flag_HK.png);
}

.flag_JP {
  background-image: url(../../assets/flag/flag_JP.png);
}

.flag_KR {
  background-image: url(../../assets/flag/flag_KR.png);
}

.flag_RU {
  background-image: url(../../assets/flag/flag_RU.png);
}

.flag_SG {
  background-image: url(../../assets/flag/flag_SIN.png);
}

.flag_TH {
  background-image: url(../../assets/flag/flag_TH.png);
}

.flag_AE {
  background-image: url(../../assets/flag/flag_UAE.png);
}

.flag_US {
  background-image: url(../../assets/flag/flag_US.png);
}

.flag_VN {
  background-image: url(../../assets/flag/flag_VN.png);
}


header {
  background: #fff;
  box-shadow: 0px -1px 0px 0px rgba(236, 238, 240, 1);

  .header_l {
    padding: 31px 0;

    .logo_icon {
      width: 196px;
      height: 48px;
      background: url(../../assets/header/pic_com_logo.png) no-repeat center;
      background-size: 100% 100%;
      cursor: pointer;
    }

    dl {
      height: 48px;
      border-left: 1px solid #BFBFBF;
      padding-left: 15px;
      margin-left: 16px;

      dt {
        font-size: 14px;
        font-weight: 400;
        color: rgba(128, 128, 128, 1);
        line-height: 16px;
        margin-top: 4px;
        margin-bottom: 8px;
      }

      dd {
        font-size: 14px;
        font-weight: normal;
        color: rgba(128, 128, 128, 1);
        line-height: 16px;
      }
    }
  }

  .header_r {
    padding-top: 43px;
    height: 40px;

    li {
      font-size: 16px;
      font-family: SFUIText-Regular, SFUIText;
      font-weight: 400;
      color: rgba(128, 128, 128, 1);
      height: 24px;
      line-height: 24px;

      &:first-child {
        border-right: 1px solid #BFBFBF;
        padding-right: 16px;
        margin-right: 31px;

        a {
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url(../../assets/header/icon_nav_facebook.png) no-repeat center;
          background-size: 100% 100%;
        }
      }

      &:nth-child(2) {
        display: inline-block;
        margin-right: 32px;
        position: relative;

        a {
          color: #808080;
          // &::before {
          //   content:'';
          //   float: left;
          //   width: 24px;
          //   height: 24px;
          //   margin-right: 8px;
          //   background: url(../../assets/header/icon_nav_country.png) no-repeat center;
          //   background-size: 100% 100%;
          // }
          i {
            display: inline-block;
            width: 24px;
            height: 12px;
            margin-right: 8px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
          }

          &::after {
            content: '';
            float: right;
            width: 16px;
            height: 16px;
            margin-left: 4px;
            margin-top: 3px;
            background-image: url(../../assets/header/icon_com_sj_down.png);
            background-repeat: no-repeat;
            background-origin: center;
            background-size: 100% 100%;
          }
        }

        .show_c_box {
          z-index: 100;
          position: absolute;
          right: 0;
          top: 32px;
          width: 296px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(236, 238, 240, 1);
          padding: 32px 16px;

          p {
            font-size: 12px;
            color: #808080;
            margin-bottom: 8px;
          }

          .countryList, .language_sty {
            width: 264px;
            height: 48px;
            line-height: 48px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(236, 238, 240, 1);

            a {
              display: inline-block;
              width: 100%;
              height: 100%;
              padding: 0 16px;

              &::after {
                margin-top: 16px;
              }
            }
          }

          .countryList {
            margin-bottom: 16px;
            position: relative;

            .c_list_sty {
              position: absolute;
              left: -1px;
              overflow-y: auto;
              width: 264px;
              max-height: 242px !important;
              background: rgba(255, 255, 255, 1);
              box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.1);
              border: 1px solid rgba(236, 238, 240, 1);

              &::-webkit-scrollbar {
                width: 8px;
                border-radius: 5px;
              }

              &::-webkit-scrollbar-thumb {
                background-color: #ECEEF0;
                border-radius: 5px;
              }

              a {
                height: 40px;
                line-height: 40px;

                &:hover {
                  background-color: #D8D8D8;
                }

                &::after {
                  display: none;
                  margin-top: 10px;
                }
              }
            }
          }

          .language_sty {
            margin-bottom: 32px;

            a {
              &::before {
                display: none;
              }
            }
          }

          input {
            cursor: pointer;
            width: 264px;
            height: 48px;
            background: rgba(216, 0, 15, 1);
            border-radius: 4px;
            font-size: 16px;
            color: #fff;
          }
        }
      }

      &:nth-child(3) {
        display: flex;
        align-items: center;
        
        .auth-buttons {
          display: flex;
          align-items: center;
          gap: 16px;
          height: 100%;
          
          .login-btn, .signup-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 8px 24px;
            border-radius: 6px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 16px;
            line-height: 1.5em;
            text-align: center;
            cursor: pointer;
            border: none;
            transition: all 0.3s ease;
            height: 40px;
          }
          
          .login-btn {
            background: #FBE9E7;
            color: #D8000F;
            
            &:hover {
              background: #F5D5D1;
            }
          }
          
          .signup-btn {
            background: #D8000F;
            color: #FFFFFF;
            
            &:hover {
              background: #B8000D;
            }
          }
        }
      }
    }
  }
}
</style>
